import { API_BASE_URL } from './constants';
import useStore from '../hooks/useStore';

const request = (options) => {
    const headers = new Headers({
        'Content-Type': 'application/json',
    })

    const defaults = { headers: headers, credentials: 'include' };
    options = Object.assign({}, defaults, options);

    return fetch(options.url, options)
        .then(response => {
            const contentType = response.headers.get('content-type');
            const hasJson = contentType && contentType.includes('application/json');
            if (!hasJson) {
                if (!response.ok) return Promise.reject({ status: response.status });
                return {};
            }
            return response.json().then(json => {
                if (!response.ok) return Promise.reject(json);
                return json;
            });
        });
};

export function authHeader(contentType = null) {
    if (contentType != null) {
        return { "Content-Type": contentType, "Accept-Language": "gr" };
    }
    return { 'Content-Type': 'application/json', "Accept-Language": "gr" };
}

export function getCurrentUser() {
    return request({
        url: API_BASE_URL + "/user/me",
        method: 'GET'
    });
}

export function cleancookies() {
    return request({
        url: API_BASE_URL + "/user/cleancookies",
        method: 'POST'
    });
}

export function login(loginRequest) {
    return request({
        url: API_BASE_URL + "/auth/login",
        method: 'POST',
        body: JSON.stringify(loginRequest)
    });
}

export function signup(signupRequest) {
    return request({
        url: API_BASE_URL + "/auth/signup",
        method: 'POST',
        body: JSON.stringify(signupRequest)
    });
}

export function setup2FA() {
    return request({
        url: API_BASE_URL + "/2fa/setup",
        method: 'GET'
    });
}

export function enable2FA(code) {
    return request({
        url: API_BASE_URL + "/2fa/enable",
        method: 'POST',
        body: JSON.stringify({ code })
    });
}

export function disable2FA() {
    return request({
        url: API_BASE_URL + "/2fa/disable",
        method: 'POST'
    });
}

export function get2FAStatus() {
    return request({
        url: API_BASE_URL + "/2fa/status",
        method: 'GET'
    });
}

export function validate2FA(code) {
    return request({
        url: API_BASE_URL + "/2fa/validate",
        method: 'POST',
        body: JSON.stringify({ code })
    });
}

export function logout() {
    return fetch(API_BASE_URL + "/auth/logout", {
        method: 'POST',
        credentials: 'include'
    }).finally(() => {
        localStorage.removeItem("user");
        // localStorage.removeItem("company");
        localStorage.removeItem("accessToken");
        useStore.setState({ loggedInUser: null,  accessToken: null, bootstrapped: false });
        window.location.href = '/login';
    });
}